module.exports = __webpack_public_path__ + "static/media/bench-park-city-elements-svgrepo-com.c274e963.svg";